import { Navigate } from "react-router-dom";
const DefaultPage = ({ children }) => {
    return <Navigate to="/login" />;
};

export default DefaultPage;
